<template>
  <div class="legal-page">
    <!-- Decorative background icons -->
    <div class="legal-page__decor legal-page__decor--left">
      <svg class="decor-icon decor-icon--1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg class="decor-icon decor-icon--2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" stroke-width="1.5"/>
        <path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      <svg class="decor-icon decor-icon--3" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
        <path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" stroke="currentColor" stroke-width="1.5"/>
      </svg>
      <svg class="decor-icon decor-icon--4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="1.5"/>
        <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
      </svg>
    </div>
    <div class="legal-page__decor legal-page__decor--right">
      <svg class="decor-icon decor-icon--5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="1.5"/>
      </svg>
      <svg class="decor-icon decor-icon--6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg class="decor-icon decor-icon--7" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg class="decor-icon decor-icon--8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
        <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </div>
    <div class="legal-page__header">
      <button
        type="button"
        class="legal-page__back"
        aria-label="Go back"
        @click="goBack"
      >
        <i class="fas fa-arrow-left"></i>
      </button>
      <h1 class="legal-page__title">{{ translatedData?.title }}</h1>
    </div>
    <div class="legal-page__content">
      <p>
        <strong>{{ translatedData?.updated_effective_date }}</strong>
      </p>
      <p>{{ translatedData?.privacy_policy_description }}</p>
      <p>{{ translatedData?.review_policy_note }}</p>

      <p><strong>{{ translatedData?.privacy_joint_applicants_title }}</strong></p>
      <p>{{ translatedData?.privacy_joint_applicants_info }}</p>

      <p><strong>{{ translatedData?.candid_collect_info_title }}</strong></p>
      <p><strong>{{ translatedData?.categories_of_information_title }}</strong></p>
      <p>{{ translatedData?.categories_of_information_content }}</p>
      <ul>
        <li>{{ translatedData?.identifiers }}</li>
        <li>{{ translatedData?.commercial_information }}</li>
        <li>{{ translatedData?.financial_information }}</li>
        <li>{{ translatedData?.internet_device_activity }}</li>
        <li>{{ translatedData?.geolocation_information }}</li>
        <li>{{ translatedData?.professional_employment_data }}</li>
        <li>{{ translatedData?.education_data }}</li>
        <li>{{ translatedData?.protected_classification_data }}</li>
        <li>{{ translatedData?.insurance_information }}</li>
        <li>{{ translatedData?.physical_characteristics }}</li>
        <li>{{ translatedData?.inference_data }}</li>
        <li>{{ translatedData?.other_information }}</li>
      </ul>

      <p><strong>{{ translatedData?.categories_of_sources_title }}</strong></p>
      <p>{{ translatedData?.categories_of_sources_content }}</p>

      <p><strong>{{ translatedData?.information_provided_directly_title }}</strong></p>
      <p>{{ translatedData?.information_provided_directly_content }}</p>
      <ul>
        <li>{{ translatedData?.register_account }}</li>
        <li>{{ translatedData?.enter_information }}</li>
        <li>{{ translatedData?.communicate_with_us }}</li>
        <li>{{ translatedData?.connect_third_party }}</li>
      </ul>
      <p>{{ translatedData?.example_registration_process }}</p>

      <p><strong>{{ translatedData?.information_collected_passively_title }}</strong></p>
      <p>
        <strong>{{ translatedData?.device_usage_information_title }}</strong>
        {{ translatedData?.device_usage_information_content }}
      </p>
      <p>
        <strong>{{ translatedData?.cookies_technologies_title }}</strong>
        {{ translatedData?.cookies_technologies_content }}
      </p>
      <p>
        <strong>{{ translatedData?.blocking_cookies_title }}</strong>
        {{ translatedData?.blocking_cookies_content }}
        <u><a href="http://windows.microsoft.com/en-US/windows-vista/Block-or-allow-cookies" target="_blank">{{ translatedData?.connect_third_party_ie }}</a></u>;
        <u><a href="https://support.google.com/chrome/answer/95647?hl=en" target="_blank">{{ translatedData?.connect_third_party_chrome }}</a></u>;
        <u><a href="http://kb.mozillazine.org/Cookies#Firefox" target="_blank">{{ translatedData?.connect_third_party_firefox }}</a></u>; or
        <u><a href="http://support.apple.com/kb/PH5042" target="_blank">{{ translatedData?.connect_third_party_safari }}</a></u>
        {{ translatedData?.connect_third_party_end }}
      </p>

      <p><strong>{{ translatedData?.information_from_third_parties_title }}</strong></p>
      <p>{{ translatedData?.information_from_third_parties_content }}</p>

      <p><strong>{{ translatedData?.how_candid_uses_information_title }}</strong></p>
      <p>{{ translatedData?.how_candid_uses_information_content }}</p>
      <ul>
        <li>{{ translatedData?.performing_services }}
          <ul>
            <li>{{ translatedData?.processing_transaction }}</li>
            <li>{{ translatedData?.facilitating_registration }}</li>
            <li>{{ translatedData?.sending_activity_information }}</li>
          </ul>
        </li>
        <li>{{ translatedData?.detecting_security_incidents }}</li>
        <li>{{ translatedData?.debugging_platform }}</li>
        <li>{{ translatedData?.short_term_use }}</li>
        <li>{{ translatedData?.undertaking_research_reporting }}</li>
        <li>{{ translatedData?.technological_development }}</li>
        <li>{{ translatedData?.contacting_users }}</li>
        <li>{{ translatedData?.processing_inquiries }}</li>
        <li>{{ translatedData?.personalizing_content }}</li>
        <li>{{ translatedData?.enforcing_legal_terms }}</li>
      </ul>
      <p>{{ translatedData?.aggregated_deidentified_information }}</p>

      <p><strong>{{ translatedData?.personalizing_content_title }}</strong></p>
      <p>
        <strong>{{ translatedData?.online_email_analytics_title }}</strong>
        {{ translatedData?.online_email_analytics_content }}
        <u><a href="https://tools.google.com/dlpage/gaoptout" target="_blank">{{ translatedData?.online_email_analytics_content_1 }}</a></u>
        {{ translatedData?.online_email_analytics_content_2 }}
      </p>
      <p>
        <strong>{{ translatedData?.do_not_track_notice_title }}</strong>
        {{ translatedData?.do_not_track_notice_content }}
        <u><a href="http://allaboutdnt.com/" target="_blank">{{ translatedData?.do_not_track_notice_content_1 }}</a></u>.
      </p>

      <p><strong>{{ translatedData?.how_candid_shares_information_title }}</strong></p>
      <p>{{ translatedData?.information_sharing_notice }}</p>
      <p>
        <u>{{ translatedData?.financial_services_providers_title }}</u>
        {{ translatedData?.financial_services_providers_content }}
      </p>
      <p>
        <u>{{ translatedData?.affiliates_subsidiaries_title }}</u>
        {{ translatedData?.affiliates_subsidiaries_content }}
      </p>
      <p>
        <u>{{ translatedData?.service_providers_title }}</u>
        {{ translatedData?.service_providers_content }}
      </p>
      <p>
        <u>{{ translatedData?.data_access_providers_title }}</u>
        {{ translatedData?.data_access_providers_content }}
        <u><a href="https://plaid.com/legal/#Privacy-Policy" target="_blank">{{ translatedData?.data_access_providers_content_1 }}</a></u>,
        <u><a href="https://www.finicity.com/privacy-policy/" target="_blank">{{ translatedData?.data_access_providers_content_2 }}</a></u>
        {{ translatedData?.data_access_providers_content_3 }}
        <u><a href="https://www.yodlee.com/legal/privacy-notice/" target="_blank">{{ translatedData?.data_access_providers_content_4 }}</a></u>
        {{ translatedData?.data_access_providers_content_5 }}
      </p>
      <p>
        <u>{{ translatedData?.consent_title }}</u>
        {{ translatedData?.consent_content }}
      </p>
      <p>
        <u>{{ translatedData?.protection_of_candid_title }}</u>
        {{ translatedData?.protection_of_candid_content }}
      </p>
      <p>
        <u>{{ translatedData?.business_transfers_title }}</u>
        {{ translatedData?.business_transfers_content }}
      </p>

      <p><strong>{{ translatedData?.data_security_title }}</strong></p>
      <p>{{ translatedData?.data_security_content }}</p>
      <p>
        {{ translatedData?.password_recommendation_content }}
        <a href="mailto:info@candid.inc">info@candid.inc</a>
        {{ translatedData?.password_recommendation_content_1 }}
      </p>

      <p><strong>{{ translatedData?.choices_title }}</strong></p>
      <p>
        <u>{{ translatedData?.updating_deleting_info_title }}</u>
        {{ translatedData?.updating_deleting_info_content }}
      </p>
      <p>
        <u>{{ translatedData?.account_access_title }}</u>
        {{ translatedData?.account_access_content }}
      </p>

      <p><strong>{{ translatedData?.california_residents_title }}</strong></p>
      <p>{{ translatedData?.california_policy_title }}</p>

      <p><strong>{{ translatedData?.right_to_know_title }}</strong></p>
      <p>{{ translatedData?.right_to_know_content }}</p>

      <p><strong>{{ translatedData?.right_to_delete_title }}</strong></p>
      <p>{{ translatedData?.right_to_delete_content }}</p>

      <p><strong>{{ translatedData?.authorized_agents_title }}</strong></p>
      <p>{{ translatedData?.authorized_agents_content }}</p>
      <ul>
        <li>{{ translatedData?.authorized_agents_content_1 }}</li>
        <li>{{ translatedData?.authorized_agents_content_2 }}</li>
        <li>{{ translatedData?.authorized_agents_content_3 }}</li>
        <li>{{ translatedData?.authorized_agents_content_4 }}</li>
      </ul>
      <p>{{ translatedData?.authorized_agents_content_5 }}</p>

      <p><strong>{{ translatedData?.additional_rights_title }}</strong></p>
      <p>
        {{ translatedData?.additional_rights_content }}
        <strong>{{ translatedData?.additional_rights_content_1 }}</strong>
      </p>

      <p><strong>{{ translatedData?.financial_incentives_title }}</strong></p>
      <p>{{ translatedData?.financial_incentives_content }}</p>

      <p><strong>{{ translatedData?.non_discrimination_rights_title }}</strong></p>
      <p>{{ translatedData?.non_discrimination_rights_content }}</p>
      <ul>
        <li>{{ translatedData?.non_discrimination_rights_content_1 }}</li>
        <li>{{ translatedData?.non_discrimination_rights_content_2 }}</li>
        <li>{{ translatedData?.non_discrimination_rights_content_3 }}</li>
        <li>{{ translatedData?.non_discrimination_rights_content_4 }}</li>
      </ul>

      <p><strong>{{ translatedData?.privacy_laws_rights_title }}</strong></p>
      <p>{{ translatedData?.privacy_laws_rights_content }}</p>

      <p><strong>{{ translatedData?.technology_service_provider_title }}</strong></p>
      <p>{{ translatedData?.technology_service_provider_content }}</p>

      <p><strong>{{ translatedData?.contact_us_title }}</strong></p>
      <p>{{ translatedData?.contact_us_content }}</p>

      <p><strong>{{ translatedData?.nevada_residents_title }}</strong></p>
      <p>{{ translatedData?.nevada_residents_content }}</p>

      <p><strong>{{ translatedData?.third_party_links_title }}</strong></p>
      <p>{{ translatedData?.third_party_links_content }}</p>

      <p><strong>{{ translatedData?.children_policy_title }}</strong></p>
      <p>{{ translatedData?.children_policy_content }}</p>

      <p><strong>{{ translatedData?.retention_of_information_title }}</strong></p>
      <p>{{ translatedData?.retention_of_information_content }}</p>

      <p><strong>{{ translatedData?.policy_changes_title }}</strong></p>
      <p>{{ translatedData?.policy_changes_content }}</p>

      <p><strong>{{ translatedData?.questions_about_policy_title }}</strong></p>
      <p>{{ translatedData?.questions_about_policy_content }}</p>
    </div>
  </div>
</template>

<script>
import privacyJson from "../data/privacy";
import { translationMixin } from "../mixins/translationMixin";

export default {
  name: "PrivacyPolicyPage",
  mixins: [translationMixin],
  data() {
    return {
      data: privacyJson,
      hasPreviousRoute: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.hasPreviousRoute = Boolean(from && from.name);
    });
  },
  methods: {
    goBack() {
      if (this.hasPreviousRoute) {
        this.$router.back();
      } else {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style scoped>
.legal-page {
  max-width: 960px;
  margin: 0 auto;
  padding: 40px 24px 80px;
  font-family: "Lato", sans-serif;
  color: #333;
  position: relative;
}

.legal-page__header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
  padding-bottom: 16px;
  border-bottom: 3px solid var(--primary-color, #000);
}

.legal-page__back {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  border-radius: 50%;
  color: var(--primary-color, #000);
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s;
  flex-shrink: 0;
  padding: 0;
}

.legal-page__back:hover {
  background-color: rgba(0, 0, 0, 0.06);
}

.legal-page__title {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}

.legal-page__content {
  line-height: 1.7;
  text-align: justify;
}

.legal-page__content p {
  margin-bottom: 14px;
  font-size: 15px;
}

.legal-page__content ol,
.legal-page__content ul {
  margin-bottom: 10px;
  padding-left: 24px;
}

.legal-page__content ul > li {
  margin-bottom: 4px;
  font-size: 15px;
}

.legal-page__content a {
  color: var(--primary-color, #000);
  text-decoration: underline;
}

.legal-page__content a:hover {
  opacity: 0.8;
}

/* Decorative Icons */
.legal-page__decor {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 120px;
  pointer-events: none;
  z-index: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 80px 0;
}

.legal-page__decor--left {
  left: 20px;
}

.legal-page__decor--right {
  right: 20px;
}

.decor-icon {
  width: 44px;
  height: 44px;
  color: var(--primary-color, #000);
  opacity: 0.08;
}

.decor-icon--1 { transform: rotate(-15deg); opacity: 0.07; width: 40px; height: 40px; }
.decor-icon--2 { transform: rotate(10deg); opacity: 0.06; width: 48px; height: 48px; align-self: flex-end; }
.decor-icon--3 { transform: rotate(-5deg); opacity: 0.09; width: 36px; height: 36px; }
.decor-icon--4 { transform: rotate(20deg); opacity: 0.05; width: 42px; height: 42px; align-self: center; }
.decor-icon--5 { transform: rotate(8deg); opacity: 0.07; width: 46px; height: 46px; align-self: flex-start; }
.decor-icon--6 { transform: rotate(-12deg); opacity: 0.06; width: 38px; height: 38px; align-self: center; }
.decor-icon--7 { transform: rotate(15deg); opacity: 0.08; width: 50px; height: 50px; align-self: flex-end; }
.decor-icon--8 { transform: rotate(-8deg); opacity: 0.05; width: 34px; height: 34px; }

.legal-page__header,
.legal-page__content {
  position: relative;
  z-index: 1;
}

@media (max-width: 1200px) {
  .legal-page__decor {
    display: none;
  }
}

@media (max-width: 767px) {
  .legal-page {
    padding: 24px 16px 60px;
  }

  .legal-page__title {
    font-size: 20px;
  }

  .legal-page__content p,
  .legal-page__content ul > li {
    font-size: 14px;
  }
}
</style>
